"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _AccessTime = _interopRequireDefault(require("@material-ui/icons/AccessTime"));

var _useProductDetailShippingDateComponent = _interopRequireDefault(require("../../../hooks/useProductDetailShippingDateComponent"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      color: theme.palette.secondary.main,
      width: 160,
      alignSelf: 'flex-end'
    },
    quantity: (0, _extends2.default)({}, theme.typography.body1, {
      fontWeight: 500
    }),
    icon: {
      width: 56,
      height: 56,
      fill: theme.palette.secondary.main
    },
    textContainer: {
      width: '100%',
      textAlign: 'center'
    }
  };
}, {
  name: 'ProductDetailClockOrder'
});

function ProductDetailClockOrder(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      hide = _ref.hide,
      product = _ref.product,
      shipping = _ref.shipping,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "hide", "product", "shipping"]);
  var classes = useStyles({
    classes: pClasses
  });
  var ProductDetailShippingDate = (0, _useProductDetailShippingDateComponent.default)();

  var _ref2 = shipping || {},
      warehouse = _ref2.warehouse;

  return !hide && warehouse ? /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    renderToGridArea: "clockArea"
  }), /*#__PURE__*/_react.default.createElement(_AccessTime.default, {
    className: classes.icon
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/_react.default.createElement(ProductDetailShippingDate, {
    shipping: shipping
  }))) : null;
}

process.env.NODE_ENV !== "production" ? ProductDetailClockOrder.propTypes = {
  classes: _propTypes.default.shape({
    icon: _propTypes.default.string,
    quantity: _propTypes.default.string,
    root: _propTypes.default.string,
    textContainer: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  hide: _propTypes.default.bool,
  product: _propTypes.default.shape({}),
  shipping: _propTypes.default.shape({
    latestOrderTime: _propTypes.default.shape({}),
    shippingDate: _propTypes.default.shape({}),
    warehouse: _propTypes.default.string
  })
} : void 0;
ProductDetailClockOrder.defaultProps = {
  classes: undefined,
  className: undefined,
  hide: undefined,
  product: undefined,
  shipping: undefined
};
var _default = ProductDetailClockOrder;
exports.default = _default;